export default {"src":"/_next/static/media/pump.f67140c9.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};